var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('chart-list',{ref:"list",on:{"load":_vm.load}}),_c('chart-composer',{ref:"composer",on:{"updated":_vm.updated,"deleted":_vm.deleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }